import { Extension } from "@tiptap/core";

export const KeyboardShortcuts = Extension.create({
  name: "keyboardShortcuts",

  addKeyboardShortcuts() {
    return {
      // Atalhos de formatação básica
      "Mod-b": ({ editor }) => editor.chain().focus().toggleBold().run(),
      "Mod-i": ({ editor }) => editor.chain().focus().toggleItalic().run(),
      "Mod-u": ({ editor }) => editor.chain().focus().toggleUnderline().run(),
      "Mod-Alt-l": () => {
        // Simular clique no botão de link para abrir a popup
        const linkButton = document.querySelector(
          '[data-action="create-link"]'
        ) as HTMLElement;
        if (linkButton) {
          linkButton.click();
        }
        return true;
      },
      "Mod-k": ({ editor }) => {
        // Abrir slash command (⌘K)
        const { view } = editor;
        const { $from } = view.state.selection;
        const pos = $from.start();
        return editor.chain().focus().insertContentAt(pos, "/").run();
      },

      // Atalhos para títulos
      "Mod-1": ({ editor }) =>
        editor.chain().focus().setHeading({ level: 1 }).run(),

      // Atalhos para listas
      "Mod-Shift-l": ({ editor }) => {
        if (editor.isActive("bulletList")) {
          return editor.chain().focus().toggleBulletList().run();
        }
        if (editor.isActive("orderedList")) {
          return editor.chain().focus().toggleOrderedList().run();
        }
        return editor.chain().focus().toggleBulletList().run();
      },
      "Mod-Shift-o": ({ editor }) =>
        editor.chain().focus().toggleOrderedList().run(),
      "Mod-Alt-t": ({ editor }) =>
        editor.chain().focus().toggleTaskList().run(),

      // Atalhos para inserção de elementos
      "Mod-Shift-i": ({ editor }) => {
        // Inserir imagem - usar o comando correto
        return editor.chain().focus().setImageUpload().run();
      },
      "Mod-Shift-b": ({ editor }) => {
        if (!editor.isActive("table")) {
          return editor
            .chain()
            .focus()
            .insertTable({ rows: 3, cols: 3, withHeaderRow: false })
            .run();
        }
        return false;
      },
      "Mod-Shift-g": ({ editor }) => {
        // Inserir gráfico
        return editor.chain().focus().insertChart().run();
      },
      "Mod-Shift-c": ({ editor }) => {
        if (!editor.isActive("columns")) {
          return editor
            .chain()
            .focus()
            .setColumns()
            .focus(editor.state.selection.head - 1)
            .run();
        }
        return false;
      },
      "Mod-Shift-h": ({ editor }) => {
        if (!editor.isActive("highlightBlock")) {
          return editor
            .chain()
            .focus()
            .insertBlock()
            .focus(editor.state.selection.head - 1)
            .run();
        }
        return false;
      },
      "Mod-Shift-s": ({ editor }) => {
        if (!editor.isActive("stepper")) {
          return editor.chain().focus().insertSteps().run();
        }
        return false;
      },

      // Atalhos para citação e código
      "Mod-Alt-q": ({ editor }) => editor.chain().focus().setBlockquote().run(),
      "Mod-Shift-r": ({ editor }) =>
        editor.chain().focus().setHorizontalRule().run(),
      "Mod-Shift-k": ({ editor }) =>
        editor.chain().focus().toggleCodeBlock().run(),

      // Atalhos para desfazer/refazer
      "Mod-z": ({ editor }) => editor.chain().focus().undo().run(),
      "Mod-y": ({ editor }) => editor.chain().focus().redo().run(),
      "Mod-Shift-z": ({ editor }) => editor.chain().focus().redo().run(),

      // Atalhos para navegação
      "Mod-a": ({ editor }) => editor.chain().focus().selectAll().run(),
      Escape: ({ editor }) => {
        // Remove seleção e foca no editor
        return editor.chain().focus().run();
      },
    };
  },
});
